import { PartialBrief } from '../../../../Types/Brief'
import {
  dateToReadableString,
  timeOptionToReadableString,
  areSameDay,
} from '../../../FormSteps/DateTime/Utilities/dateStrings'
import { getBriefDates } from '../../../FormSteps/DateTime/Utilities/getBriefDates'

interface TimingsProps {
  brief: PartialBrief
}

export const Timings = ({ brief }: TimingsProps): JSX.Element => {
  const dates = getBriefDates(brief)
  const [_startDate, _endDate] = dates
  const startDate = _startDate && dateToReadableString(_startDate)
  const endDate = _endDate && dateToReadableString(_endDate)
  const startTime = brief.fromTime && timeOptionToReadableString(brief.fromTime)
  const endTime = brief.toTime && timeOptionToReadableString(brief.toTime)

  return areSameDay(dates) ? (
    <>
      {startDate}, {startTime} - {endTime}
    </>
  ) : (
    <>
      {startDate} at {startTime} - {endDate} at {endTime}
    </>
  )
}

export default Timings
